import React, { useState, useEffect } from 'react';
import { TextField, Box, ThemeProvider } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import { orangeTheme } from './theme'; // import your theme


const DateTimeRangePicker = ({ formData, setFormData, IsDisabled, isModifyClassName = null, errors = {}, }) => {
  const { scheduleStartTime, scheduleEndTime, scheduleDate, scheduleEndDate } = formData;
  const { scheduleDateError, scheduleStartTimeError, scheduleEndDateError, scheduleEndTimeError } = errors;


  const [startDateTime, setStartDateTime] = useState(null);
  const [endDateTime, setEndDateTime] = useState(null);

  // useEffect(() => {
  //   if (scheduleDate && scheduleStartTime) {
  //     const date = dayjs(`${scheduleDate.split("T")[0]}T${scheduleStartTime}`);
  //     setStartDateTime(date);
  //   }
  // }, [scheduleDate, scheduleStartTime]);

  useEffect(() => {
    if (scheduleDate && scheduleStartTime) {
        // ✅ Extract just the date part, then combine with time
        const datePart = scheduleDate.includes('T') ? scheduleDate.split("T")[0] : scheduleDate;
        const dateTimeString = `${datePart}T${scheduleStartTime}`;
        const date = dayjs(dateTimeString);
        
        // ✅ Only update if actually different
        if (!startDateTime || !date.isSame(startDateTime)) {
            setStartDateTime(date);
        }
    }
}, [scheduleDate, scheduleStartTime]);

useEffect(() => {
    if (scheduleEndDate && scheduleEndTime) {
        // ✅ Extract just the date part, then combine with time
        const datePart = scheduleEndDate.includes('T') ? scheduleEndDate.split("T")[0] : scheduleEndDate;
        const dateTimeString = `${datePart}T${scheduleEndTime}`;
        const date = dayjs(dateTimeString);
        
        // ✅ Only update if actually different
        if (!endDateTime || !date.isSame(endDateTime)) {
            setEndDateTime(date);
        }
    }
}, [scheduleEndDate, scheduleEndTime]);

console.log('scheduleDate',scheduleDate)
console.log('scheduleStartTime',scheduleStartTime)
console.log('scheduleEndDate',scheduleEndDate)
console.log('scheduleEndTime',scheduleEndTime)

  // useEffect(() => {
  //   if (scheduleEndDate && scheduleEndTime) {
  //     const date = dayjs(`${scheduleEndDate.split("T")[0]}T${scheduleEndTime}`);
  //     setEndDateTime(date);
  //   }
  // }, [scheduleEndDate, scheduleEndTime]);

  useEffect(() => {
    if (startDateTime) {
      setFormData((prev) => ({
        ...prev,
        scheduleDate: startDateTime.format('YYYY-MM-DDTHH:mm:ss'),
        scheduleStartTime: startDateTime.format('HH:mm')
      }));
    }

    if (endDateTime) {
      setFormData((prev) => ({
        ...prev,
        scheduleEndTime: endDateTime.format('HH:mm'),
        scheduleEndDate: endDateTime.format('YYYY-MM-DDTHH:mm:ss'),
      }));
    }
  }, [startDateTime, endDateTime, setFormData]);
  const [touched, setTouched] = useState(false);


  return (
    <ThemeProvider theme={orangeTheme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {isModifyClassName ? (
          <div className="row">
            <div className={`mb-3 col-12 col-md-6 col-sm-12`}>
              <label htmlFor="startDateTime" className="form-label">Schedule From</label>
              <DateTimePicker
                label="Schedule From"
                onOpen={() => setTouched(true)}
                value={startDateTime}
                onChange={(newValue) => setStartDateTime(newValue)}
                disabled={IsDisabled}
                ampm={false}
                minDateTime={dayjs()}
                format="DD/MM/YYYY HH:mm"
                slotProps={{
                  textField: {
                    variant: "outlined",
                    placeholder: "Select date and time",
                    InputLabelProps: { shrink: true },
                    fullWidth: true,
                    label: '',
                    className: 'form-control',
                    InputProps: {
                      sx: {
                        height: 40,
                        '& input': { padding: '10px 14px' },
                      }
                    },
                    error: touched && !formData.scheduleDateTime
                  }
                }}
              />
              {(scheduleDateError || scheduleStartTimeError) && (
                <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>
                  {scheduleDateError || scheduleStartTimeError}
                </span>
              )}
            </div>

            <div className={`mb-3 col-12 col-md-6 col-sm-12`}>
              <label htmlFor="endDateTime" className="form-label">Schedule To</label>
              <DateTimePicker
                label="Schedule To"
                value={endDateTime}
                onChange={(newValue) => setEndDateTime(newValue)}
                disabled={!startDateTime}
                ampm={false}
                minDateTime={startDateTime}
                format="DD/MM/YYYY HH:mm"
                slotProps={{
                  textField: {
                    variant: 'outlined',
                    placeholder: "Select date and time",
                    fullWidth: true,
                    InputLabelProps: { shrink: true },
                    label: '',
                    className: 'form-control',
                    InputProps: {
                      sx: {
                        height: 40,
                        '& input': { padding: '10px 14px' },
                      }
                    },
                  },
                }}
              />
              {(scheduleEndDateError || scheduleEndTimeError) && (
                <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>
                  {scheduleEndDateError || scheduleEndTimeError}
                </span>
              )}
            </div>
          </div>
        ) : (
          <>
            <div className={`mb-3 col-12 col-md-4 col-sm-12`}>
              <label htmlFor="startDateTime" className="form-label">Schedule From</label>
              <DateTimePicker
                label="Schedule From"
                onOpen={() => setTouched(true)}
                value={startDateTime}
                onChange={(newValue) => setStartDateTime(newValue)}
                disabled={IsDisabled}
                ampm={false}
                minDateTime={dayjs()}
                format="DD/MM/YYYY HH:mm"
                slotProps={{
                  textField: {
                    variant: "outlined",
                    placeholder: "Select date and time",
                    InputLabelProps: { shrink: true },
                    fullWidth: true,
                    label: '',
                    className: 'form-control',
                    InputProps: {
                      sx: {
                        height: 40,
                        '& input': { padding: '10px 14px' },
                      }
                    },
                    error: touched && !formData.scheduleDateTime
                  }
                }}
              />
              {(scheduleDateError || scheduleStartTimeError) && (
                <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>
                  {scheduleDateError || scheduleStartTimeError}
                </span>
              )}
            </div>

            <div className={`mb-3 col-12 col-md-4 col-sm-12`}>
              <label htmlFor="endDateTime" className="form-label">Schedule To</label>
              <DateTimePicker
                label="Schedule To"
                value={endDateTime}
                onChange={(newValue) => setEndDateTime(newValue)}
                disabled={!startDateTime}
                ampm={false}
                minDateTime={startDateTime}
                format="DD/MM/YYYY HH:mm"
                slotProps={{
                  textField: {
                    variant: 'outlined',
                    placeholder: "Select date and time",
                    fullWidth: true,
                    InputLabelProps: { shrink: true },
                    label: '',
                    className: 'form-control',
                    InputProps: {
                      sx: {
                        height: 40,
                        '& input': { padding: '10px 14px' },
                      }
                    },
                  },
                }}
              />
              {(scheduleEndDateError || scheduleEndTimeError) && (
                <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>
                  {scheduleEndDateError || scheduleEndTimeError}
                </span>
              )}
            </div>
          </>
        )}
      </LocalizationProvider>
    </ThemeProvider>

  );
};

export default DateTimeRangePicker;
